import { Role } from '@/core/components/auth/auth.types'
import {
  getRoles,
  usersQueryOptions,
} from '@/core/components/auth/authQueryOptions'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { organizationQueryOptions } from '@/core/components/organizations/organizationQueryOptions'
import { resellerQueryOptions } from '@/core/components/resellers/resellerQueryOptions'
import { propertiesQueryOptions } from '@/core/components/sites/propertyQueryOptions'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const usersSearchSchema = z.object({
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(''),
  sortBy: z
    .enum([
      'fullName',
      'username',
      'organizationName',
      'reseller',
      'role',
      'email',
    ])
    .catch('fullName'),
  orderBy: z.enum(['asc', 'desc']).catch('desc'),
})

export const Route = createFileRoute('/_layout/dashboard/users/')({
  validateSearch: (search) => usersSearchSchema.parse(search),
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }

    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger'] ||
      auth.user?.role === Role.PropertyManager
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth } }) => {
    const roles = queryClient.ensureQueryData(getRoles(auth.token!))
    const resellers = queryClient.ensureQueryData(
      resellerQueryOptions(auth.token!)
    )
    const properties = queryClient.ensureQueryData(
      propertiesQueryOptions(auth.token!)
    )
    const organizations = queryClient.ensureQueryData(
      organizationQueryOptions(auth.token!)
    )

    const users = queryClient.ensureQueryData(usersQueryOptions(auth.token!))
    return { roles, resellers, properties, organizations, users }
  },
  pendingComponent: LoadingList,
  errorComponent: ErrorComponent,
})
